export default "__VITE_ASSET__CluK94Ww__"